
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

parcelRequire("kM5jX");
parcelRequire("haS5e");
var $bac19aac47e76386$exports = {};
var $8dbf7786c43c07a0$exports = {};
var $a4e15da6acf0a3e0$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $a4e15da6acf0a3e0$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$a4e15da6acf0a3e0$exports = $a4e15da6acf0a3e0$var$isObject;


var $13d303ab9afb5fa2$exports = {};
var $607ed4d8f2e85ef3$exports = {};
var $df90c7af3baf8377$exports = {};
/** Detect free variable `global` from Node.js. */ var $df90c7af3baf8377$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$df90c7af3baf8377$exports = $df90c7af3baf8377$var$freeGlobal;


/** Detect free variable `self`. */ var $607ed4d8f2e85ef3$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $607ed4d8f2e85ef3$var$root = $df90c7af3baf8377$exports || $607ed4d8f2e85ef3$var$freeSelf || Function("return this")();
$607ed4d8f2e85ef3$exports = $607ed4d8f2e85ef3$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $13d303ab9afb5fa2$var$now = function() {
    return $607ed4d8f2e85ef3$exports.Date.now();
};
$13d303ab9afb5fa2$exports = $13d303ab9afb5fa2$var$now;


var $f6b2fa06526cb16a$exports = {};
var $e4cbebecb0e59278$exports = {};
var $1fe1f2b7d92773cb$exports = {};
/** Used to match a single whitespace character. */ var $1fe1f2b7d92773cb$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $1fe1f2b7d92773cb$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $1fe1f2b7d92773cb$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$1fe1f2b7d92773cb$exports = $1fe1f2b7d92773cb$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $e4cbebecb0e59278$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $e4cbebecb0e59278$var$baseTrim(string) {
    return string ? string.slice(0, $1fe1f2b7d92773cb$exports(string) + 1).replace($e4cbebecb0e59278$var$reTrimStart, "") : string;
}
$e4cbebecb0e59278$exports = $e4cbebecb0e59278$var$baseTrim;



var $059845e3a52d04e6$exports = {};
var $db96921a978a0194$exports = {};
var $84fcc49377fe3f23$exports = {};

/** Built-in value references. */ var $84fcc49377fe3f23$var$Symbol = $607ed4d8f2e85ef3$exports.Symbol;
$84fcc49377fe3f23$exports = $84fcc49377fe3f23$var$Symbol;


var $4b7503ee9a310b5e$exports = {};

/** Used for built-in method references. */ var $4b7503ee9a310b5e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4b7503ee9a310b5e$var$hasOwnProperty = $4b7503ee9a310b5e$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4b7503ee9a310b5e$var$nativeObjectToString = $4b7503ee9a310b5e$var$objectProto.toString;
/** Built-in value references. */ var $4b7503ee9a310b5e$var$symToStringTag = $84fcc49377fe3f23$exports ? $84fcc49377fe3f23$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $4b7503ee9a310b5e$var$getRawTag(value) {
    var isOwn = $4b7503ee9a310b5e$var$hasOwnProperty.call(value, $4b7503ee9a310b5e$var$symToStringTag), tag = value[$4b7503ee9a310b5e$var$symToStringTag];
    try {
        value[$4b7503ee9a310b5e$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $4b7503ee9a310b5e$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$4b7503ee9a310b5e$var$symToStringTag] = tag;
        else delete value[$4b7503ee9a310b5e$var$symToStringTag];
    }
    return result;
}
$4b7503ee9a310b5e$exports = $4b7503ee9a310b5e$var$getRawTag;


var $7987b17fc6bbaf8d$exports = {};
/** Used for built-in method references. */ var $7987b17fc6bbaf8d$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7987b17fc6bbaf8d$var$nativeObjectToString = $7987b17fc6bbaf8d$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $7987b17fc6bbaf8d$var$objectToString(value) {
    return $7987b17fc6bbaf8d$var$nativeObjectToString.call(value);
}
$7987b17fc6bbaf8d$exports = $7987b17fc6bbaf8d$var$objectToString;


/** `Object#toString` result references. */ var $db96921a978a0194$var$nullTag = "[object Null]", $db96921a978a0194$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $db96921a978a0194$var$symToStringTag = $84fcc49377fe3f23$exports ? $84fcc49377fe3f23$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $db96921a978a0194$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $db96921a978a0194$var$undefinedTag : $db96921a978a0194$var$nullTag;
    return $db96921a978a0194$var$symToStringTag && $db96921a978a0194$var$symToStringTag in Object(value) ? $4b7503ee9a310b5e$exports(value) : $7987b17fc6bbaf8d$exports(value);
}
$db96921a978a0194$exports = $db96921a978a0194$var$baseGetTag;


var $5bb27290c24e737b$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5bb27290c24e737b$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$5bb27290c24e737b$exports = $5bb27290c24e737b$var$isObjectLike;


/** `Object#toString` result references. */ var $059845e3a52d04e6$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $059845e3a52d04e6$var$isSymbol(value) {
    return typeof value == "symbol" || $5bb27290c24e737b$exports(value) && $db96921a978a0194$exports(value) == $059845e3a52d04e6$var$symbolTag;
}
$059845e3a52d04e6$exports = $059845e3a52d04e6$var$isSymbol;


/** Used as references for various `Number` constants. */ var $f6b2fa06526cb16a$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $f6b2fa06526cb16a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $f6b2fa06526cb16a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $f6b2fa06526cb16a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $f6b2fa06526cb16a$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $f6b2fa06526cb16a$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($059845e3a52d04e6$exports(value)) return $f6b2fa06526cb16a$var$NAN;
    if ($a4e15da6acf0a3e0$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $a4e15da6acf0a3e0$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $e4cbebecb0e59278$exports(value);
    var isBinary = $f6b2fa06526cb16a$var$reIsBinary.test(value);
    return isBinary || $f6b2fa06526cb16a$var$reIsOctal.test(value) ? $f6b2fa06526cb16a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $f6b2fa06526cb16a$var$reIsBadHex.test(value) ? $f6b2fa06526cb16a$var$NAN : +value;
}
$f6b2fa06526cb16a$exports = $f6b2fa06526cb16a$var$toNumber;


/** Error message constants. */ var $8dbf7786c43c07a0$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8dbf7786c43c07a0$var$nativeMax = Math.max, $8dbf7786c43c07a0$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $8dbf7786c43c07a0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($8dbf7786c43c07a0$var$FUNC_ERROR_TEXT);
    wait = $f6b2fa06526cb16a$exports(wait) || 0;
    if ($a4e15da6acf0a3e0$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $8dbf7786c43c07a0$var$nativeMax($f6b2fa06526cb16a$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $8dbf7786c43c07a0$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $13d303ab9afb5fa2$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($13d303ab9afb5fa2$exports());
    }
    function debounced() {
        var time = $13d303ab9afb5fa2$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$8dbf7786c43c07a0$exports = $8dbf7786c43c07a0$var$debounce;



/** Error message constants. */ var $bac19aac47e76386$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $bac19aac47e76386$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($bac19aac47e76386$var$FUNC_ERROR_TEXT);
    if ($a4e15da6acf0a3e0$exports(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $8dbf7786c43c07a0$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$bac19aac47e76386$exports = $bac19aac47e76386$var$throttle;


const $5e52f9a7b1dcd4e4$var$scrollToTop = document.querySelector(".scroll-to-top");
const $5e52f9a7b1dcd4e4$var$trackScrollThrottle = (0, (/*@__PURE__*/$parcel$interopDefault($bac19aac47e76386$exports)))($5e52f9a7b1dcd4e4$var$trackScroll, 500);
window.addEventListener("scroll", $5e52f9a7b1dcd4e4$var$trackScrollThrottle);
function $5e52f9a7b1dcd4e4$var$trackScroll() {
    const offset = window.scrollY;
    const coords = document.documentElement.clientHeight;
    function goToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    if (offset >= coords) {
        $5e52f9a7b1dcd4e4$var$scrollToTop.addEventListener("click", goToTop);
        $5e52f9a7b1dcd4e4$var$scrollToTop.classList.remove("unvisually");
    } else {
        $5e52f9a7b1dcd4e4$var$scrollToTop.classList.add("unvisually");
        $5e52f9a7b1dcd4e4$var$scrollToTop.addEventListener("click", goToTop);
    }
}


parcelRequire("fQwj1");

var $lXnOV = parcelRequire("lXnOV");

var $lXnOV = parcelRequire("lXnOV");

var $7IoHk = parcelRequire("7IoHk");

"use strict";
const $792c4a6cc187f9c0$var$title = document.querySelector(".category__title");
const $792c4a6cc187f9c0$var$listBooksByCategory = document.querySelector(".category__list");
const $792c4a6cc187f9c0$var$bookCategoriesList = document.querySelector(".side-bar__categories");
const $792c4a6cc187f9c0$var$bookGallery = document.querySelector(".books-gallery");
const $792c4a6cc187f9c0$var$category = document.querySelector(".category");
const $792c4a6cc187f9c0$export$e78a6a47f95bd591 = async (selectedCategory)=>{
    const books = await (0, $lXnOV.fetchBooksByCategory)(selectedCategory);
    if (books.length === 0) {
        (0, (/*@__PURE__*/$parcel$interopDefault($7IoHk))).Notify.info(`Unfortunately, we do not have these books at the moment.`);
        return;
    }
    const list = books.map((book)=>`<li class="category__item" data-id="${book._id}">
        <div class="category__cover"><img class="category__image" alt="book cover" src="${book.book_image}"/></div>
        <div class="category__image-description"><h4 class="category__book-title">${book.title}</h4>
        <p class="category__book-author">${book.author}</p></div> 
    </li>`).join("");
    $792c4a6cc187f9c0$var$listBooksByCategory.innerHTML = list;
};
const $792c4a6cc187f9c0$export$f111f978dc89e8bf = async (e)=>{
    if (e.target.closest("li") && e.target.textContent != "All categories") {
        $792c4a6cc187f9c0$var$bookGallery.classList.add("gallery-hidden");
        $792c4a6cc187f9c0$var$category.classList.remove("gallery-hidden");
        let selectedCategory = e.target.closest("li").textContent;
        const words = selectedCategory.split(" ");
        const lastWord = words.pop();
        const titleShort = words.join(" ");
        $792c4a6cc187f9c0$var$title.innerHTML = `${titleShort} <span class="last-word-color">${lastWord}</span>`;
        $792c4a6cc187f9c0$var$listBooksByCategory.innerHTML = "";
        $792c4a6cc187f9c0$export$e78a6a47f95bd591(selectedCategory);
    } else if (e.target.textContent === "SEE MORE") {
        $792c4a6cc187f9c0$var$bookGallery.classList.add("gallery-hidden");
        $792c4a6cc187f9c0$var$category.classList.remove("gallery-hidden");
        let selectedCategory = e.target.name;
        const words = selectedCategory.split(" ");
        const lastWord = words.pop();
        const titleShort = words.join(" ");
        $792c4a6cc187f9c0$var$title.innerHTML = `${titleShort} <span class="last-word-color">${lastWord}</span>`;
        $792c4a6cc187f9c0$var$listBooksByCategory.innerHTML = "";
        $792c4a6cc187f9c0$export$e78a6a47f95bd591(selectedCategory);
    }
};
$792c4a6cc187f9c0$var$bookCategoriesList.addEventListener("click", $792c4a6cc187f9c0$export$f111f978dc89e8bf);



var $7IoHk = parcelRequire("7IoHk");

const $aa6930de9b2418b7$var$booksGallery = document.querySelector(".books-gallery");
const $aa6930de9b2418b7$var$allCategories = document.querySelector(".side-bar__categories-item");
const $aa6930de9b2418b7$var$category = document.querySelector(".category");
function $aa6930de9b2418b7$var$seeMore() {
    const seeMoreBtn = document.querySelectorAll(".books-gallery__button");
    seeMoreBtn.forEach((button)=>button.addEventListener("click", (0, $792c4a6cc187f9c0$export$f111f978dc89e8bf)));
}
async function $aa6930de9b2418b7$var$renderBestsellerGallery() {
    const bestsellers = await (0, $lXnOV.fetchTopBooksInCategories)();
    const bestsellersSliced = bestsellers.slice(0, 4);
    if (bestsellersSliced.length === 0) {
        (0, (/*@__PURE__*/$parcel$interopDefault($7IoHk))).Notify.info(`Unfortunately, we do not have these books at the moment.`);
        return;
    }
    const bestsellersCategory = bestsellersSliced.map((bestseller)=>`<div>
        <h2 class="books-gallery__category-title">${bestseller.list_name}</h2>
    <ul class="books-gallery__section">

    <li data-id="${bestseller.books[0]._id}"><div class="category__cover"><img class="category__image" alt="book cover" src="${bestseller.books[0].book_image}"> </div> <h3 class="books-gallery__book-title">${bestseller.books[0].title}</h3><h4 class="books-gallery__book-author">${bestseller.books[0].author}</h4> </li>

    <li class="is-hidden-tablet" data-id="${bestseller.books[1]._id}"><div class="category__cover"><img class="category__image" alt="book cover" src="${bestseller.books[1].book_image}"> </div><h3 class="books-gallery__book-title">${bestseller.books[1].title}</h3><h4 class="books-gallery__book-author">${bestseller.books[1].author}</h4> </li>

    <li class="is-hidden-tablet" data-id="${bestseller.books[2]._id}"><div class="category__cover"><img class="category__image" alt="book cover" src="${bestseller.books[2].book_image}"> </div> <h3 class="books-gallery__book-title">${bestseller.books[2].title}</h3><h4 class="books-gallery__book-author">${bestseller.books[2].author}</h4> </li>

    <li class="is-hidden-desktop" data-id="${bestseller.books[3]._id}"><div class="category__cover"><img class="category__image" alt="book cover" src="${bestseller.books[3].book_image}"> </div> <h3 class="books-gallery__book-title">${bestseller.books[3].title}</h3><h4 class="books-gallery__book-author">${bestseller.books[3].author}</h4> </li>

    <li class="is-hidden-desktop" data-id="${bestseller.books[4]._id}"><div class="category__cover"><img class="category__image" alt="book cover" src="${bestseller.books[4].book_image}"> </div> <h3 class="books-gallery__book-title">${bestseller.books[4].title}</h3><h4 class="books-gallery__book-author">${bestseller.books[4].author}</h4> </li>

    </ul>
    
    <div class="books-gallery__button-wrapper"><button name="${bestseller.list_name}" type="button" class="books-gallery__button">SEE MORE</button></div>
    </div>`).join("");
    $aa6930de9b2418b7$var$booksGallery.insertAdjacentHTML("beforeend", bestsellersCategory);
    $aa6930de9b2418b7$var$seeMore();
}
$aa6930de9b2418b7$var$renderBestsellerGallery();
const $aa6930de9b2418b7$var$showAllCategories = ()=>{
    $aa6930de9b2418b7$var$booksGallery.classList.remove("gallery-hidden");
    $aa6930de9b2418b7$var$category.classList.add("gallery-hidden");
};
$aa6930de9b2418b7$var$allCategories.addEventListener("click", $aa6930de9b2418b7$var$showAllCategories);



var $lXnOV = parcelRequire("lXnOV");
const $6e660f1dfa9449aa$var$bookCategories = document.querySelector(".side-bar__categories");
async function $6e660f1dfa9449aa$var$createCategoryList() {
    const categories = await (0, $lXnOV.fetchBooksCategoryList)();
    const categoriesList = categories.map((category)=>`<li tabindex='-1' class="side-bar__categories-item">${category.list_name}</li>`).join("");
    $6e660f1dfa9449aa$var$bookCategories.insertAdjacentHTML("beforeend", categoriesList);
}
$6e660f1dfa9449aa$var$createCategoryList();


parcelRequire("a7nVE");

parcelRequire("1fSMk");
parcelRequire("2DTLi");
parcelRequire("eNCUi");


//# sourceMappingURL=index.bddbab6e.js.map
